import { render, staticRenderFns } from "./ChartModal.vue?vue&type=template&id=9c620a8c&scoped=true&"
import script from "./ChartModal.vue?vue&type=script&lang=js&"
export * from "./ChartModal.vue?vue&type=script&lang=js&"
import style0 from "./ChartModal.vue?vue&type=style&index=0&id=9c620a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c620a8c",
  null
  
)

export default component.exports